import { DataService } from 'src/app/services/dataStore/data.service';
import { AlertService } from './../../services/alert/alert.service';
import { ImportExcelService } from './../../services/importExcel/import-excel.service';
import { DateFilterService } from './../../services/date/date-filter.service';
import { SharedService } from 'src/app/services/shared.service';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { MessageService } from 'primeng/api';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/auth/auth-service.service';
import { MatSidenav } from '@angular/material/sidenav';
import { Calendar } from 'primeng/calendar';
import { PermissionService } from 'src/app/services/permission.service';
import { OverlayPanel } from 'primeng/overlaypanel';
declare let google: any;

export interface updateColumn {
  idtabColumn: number;
  ColumnPos: number;
  isActive: boolean;
}

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
  // encapsulation: ViewEncapsulation.Emulated
})
export class InvoiceComponent implements OnInit {
  displayInvoicePage: boolean = true;
  activeMenuName: string = 'invoice';
  showPaginator: boolean;
  invoiceDisplayData = [];
  allInvoiceLength: number;
  showPaginatorAllInvoice: boolean;
  createInvoice: boolean;
  allSearchInvoiceString = [];
  visibleSidebar2: boolean;
  cols: any;
  invoiceColumns: any;
  poColumns: any;
  archivedColumns: any;
  allColumns: any;
  columnstodisplayInvoice = [];
  columnstodisplayPO = [];
  columnstodisplayArchived = [];

  updateColumns: updateColumn[] = [];
  poDispalyData: any[];
  poArrayLength: number;
  GRNDispalyData: any[];
  GRNArrayLength: number;
  receiptDispalyData: any[];
  receiptArrayLength: number = 0;
  archivedDisplayData: any[] = [];
  archivedArrayLength: number;
  showPaginatorArchived: boolean;
  archivedLength: number;
  rejectedDisplayData: any[] = [];
  // rejectedArrayLength: number;
  showPaginatorRejected: boolean;
  rejectedLength: number;
  showPaginatorPOTable: boolean;
  showPaginatorGRNTable: boolean;
  userDetails: any;
  usertypeBoolean: boolean;

  rangeDates: Date[];
  rangeDatesinv: Date[];
  rangeDates_soa: Date[];
  routeName: string;
  lastYear: number;
  displayYear: string;
  minDate: Date;
  maxDate: Date;
  GRNMinDate: Date;
  columnstodisplayService = [];
  serviceColumns: any;
  showPaginatorServiceInvoice: boolean;
  serviceinvoiceDispalyData: any[];
  serviceInvoiceLength: number;
  allInColumnLength: any;
  allPOColumnLength: any;
  allARCColumnLength: any;
  allSRVColumnLength: any;
  filterData: any[];
  filterds: any[];
  filterDataService: any[];
  totalInvoicesData: any[];
  filterDataArchived: any;
  dropdownGroups: any[] = [];
  selectedType: string | null = null;

  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('op') op:OverlayPanel;
  events: string[] = [];
  opened: boolean;
  portal_name: string;
  invoiceTab: any;
  POTab: any;
  GRNTab: any;
  archivedTab: any;
  rejectedTab: any;
  serviceInvoiceTab: any;
  first: any;
  searchStr: string;
  GRNCreateBool: boolean;
  vendorInvoiceAccess: boolean;
  serviceInvoiceAccess: boolean;
  invoceDoctype = false;
  partyType: string;
  isDesktop: boolean;
  tableImportData: any;
  refreshBool: boolean;
  invTabAllColumns: any;
  poTabAllColumns: any;
  arcTabAllColumns: any;
  invsTabAllColumns: any;
  showFactsComponent: boolean;
  userEmailID: string;
  dialogHeader: string;
  entityName: any;
  selectedEntityId: any;
  entityList: any;
  filteredEnt: any[];
  vendorsList: any;
  filteredVendors: any;
  grnTabDownloadOpt = 'Pending';
  cardCount: number;
  searchText: string;
  ERPName: any;
  servicesList: any[];
  filteredService: any[];
  userList: any[];
  createdById: any;
  createdByUser: any;
  selectedVendorIdGRN: any;
  previousUrl: string;
  isAdmin: boolean;

  close(reason: string) {
    this.sidenav.close();
  }
  APIParams: string;

  rejectedColumns: any = [];
  columnstodisplayrejected: any = [];
  rejectedColumnLength: number;

  GRNColumns: any = [];
  columnstodisplayGRN: any = [];
  GRNColumnLength: number;
  factsList = ['Accounts payable professionals are like financial superheroes, ensuring the bills get paid on time to keep the business running smoothly',
    'AI can be as smart as your pet! The AI in your smartphone can recognize your face, just like your dog knows you by sight.',
    "It's like magic! OCR can turn handwritten notes into searchable text on your computer",
    "Automation in accounts payable has become more prevalent, with AI and OCR technology used to streamline invoice processing and reduce errors"];
  search_placeholder = 'Ex : By Vendor. By PO, Select Date range from the Calendar icon';
  @ViewChild('datePicker') datePicker: Calendar;
  @ViewChild('datePicker_grn') datePicker_grn: Calendar;
  @ViewChild('datePicker_soa') datePicker_soa: Calendar;
  pageNumber: number = 1;
  pageId: string = 'Inv';
  maxSize = 7;

  selectedVendorId: any;
  selectedServiceId: any;
  soa_uniSearch: string;
  SOATableData = [];
  columnsForSOA = [
    { dbColumnname: 'VendorName', columnName: 'Vendor Name' },
    { dbColumnname: 'EntityName', columnName: 'Entity' },
    { dbColumnname: 'InvoiceNo', columnName: 'Invoice Number' },
    { dbColumnname: 'PurchaseOrder', columnName: 'PO Number' },
    { dbColumnname: 'GRN Number', columnName: 'GRN Number' },
    { dbColumnname: 'Invoice Status', columnName: 'Invoice Status' },
    { dbColumnname: 'Description', columnName: 'Description' },
    { dbColumnname: 'InvoiceTotal', columnName: 'Amount' },
    { dbColumnname: 'Rejected BY', columnName: 'Rejected BY' },
  ];
  columnLengthSOA: number;
  isMobile: boolean;
  isColumnSelection: boolean = false;
  isStatusSearch: boolean = false;
  poFilterBool: boolean = false;
  GRNFilterBool: boolean = false;
  archFilterBool: boolean = false;
  rejectedFilterBool: boolean = false;
  filtereddataboolean: boolean = false;
  statusSearchText: string;
  sidebarHeader: string;
  currentlyOpenedItemIndex = -1;
  statusChartData = [];
  client_name: string;
  poRangeDates: Date[];
  selectedEntity: any;
  poNumber: string;

  constructor(
    public route: Router,
    private AlertService: AlertService,
    private sharedService: SharedService,
    private SpinnerService: NgxSpinnerService,
    public ds: DataService,
    private ImportExcelService: ImportExcelService,
    private dateFilterService: DateFilterService,
    private datePipe: DatePipe,
    private authService: AuthenticationService,
    private permissionService: PermissionService
  ) {
  }

  ngOnInit(): void {
    if (this.permissionService.show_document_status) {
      this.previousUrl = this.ds.getPreviousUrl();
      if (this.previousUrl?.includes('uploadtime')) {
        window.location.reload();
      }
      this.userDetails = this.authService.currentUserValue;
      this.userEmailID = this.userDetails.userdetails.email;
      this.GRNCreateBool = this.ds.configData?.enableGRN;
      this.client_name = this.ds.configData?.client_name.toLowerCase();
      this.vendorInvoiceAccess = this.ds?.configData?.vendorInvoices;
      this.serviceInvoiceAccess = this.ds?.configData?.serviceInvoices;
      this.isDesktop = this.ds.isDesktop;
      this.isMobile = this.ds.isMobile;
      this.ERPName = this.ds.configData?.erpname;
      this.userList = this.sharedService.usersList;
      this.isAdmin = this.ds.isAdmin;
      if (this.userDetails.user_type == 'customer_portal') {
        this.usertypeBoolean = true;
        this.portal_name = 'customer';
      } else if (this.userDetails.user_type == 'vendor_portal') {
        this.usertypeBoolean = false;
        this.portal_name = 'vendorPortal';
      }
      if (!this.userList && this.portal_name == 'customer') {
        this.DisplayCustomerUserDetails()
      }
      this.ds.portalName = this.portal_name;
      this.columnLengthSOA = this.columnsForSOA.length;
      this.APIParams = `?offset=1&limit=50`;

      this.routeForTabs();
      this.dateRange();
      this.restoreData();
      this.findActiveRoute();
      // this.readGRNExceptionData();
      // this.getInvoiceData();
      // this.getDisplayPOData();
      // this.getDisplayGRNdata();
      // this.getDisplayReceiptdata();
      this.deviceColumns();

    } else {
      this.route.navigate(['/customer/home'])
    }
  }


  deviceColumns() {
    if (this.ds.isDesktop) {
      // if (this.ds.invTabColumns) {
      //   this.invoiceColumns = this.ds.invTabColumns;
      //   this.invTabAllColumns = this.ds.invTabColumns;
      //   this.allInColumnLength = this.invoiceColumns.length + 1;
      //   this.columnstodisplayInvoice = this.pushColumnsField(this.invoiceColumns);
      // } else {
      //   this.getInvoiceColumns();
      // }
      // if (this.ds.poTabColumns) {
      //   this.poColumns = this.ds.poTabColumns;
      //   this.poTabAllColumns = this.ds.poTabColumns;
      //   this.allPOColumnLength = this.poColumns.length + 1;
      //   this.columnstodisplayPO = this.pushColumnsField(this.poColumns);
      // } else {
      //   this.getPOColumns();
      // }
      // if (this.ds.arcTabColumns) {
      //   this.archivedColumns = this.ds.arcTabColumns;
      //   this.arcTabAllColumns = this.ds.arcTabColumns
      //   this.allARCColumnLength = this.archivedColumns.length + 1;
      //   this.columnstodisplayArchived = this.pushColumnsField(this.archivedColumns);
      // } else {
      //   this.getArchivedColumns();
      // }
      // if (this.ds.serTabColumns) {
      //   this.serviceColumns = this.ds.serTabColumns;
      //   this.invsTabAllColumns = this.ds.serTabColumns;
      //   this.allSRVColumnLength = this.serviceColumns.length + 1;
      //   this.columnstodisplayService = this.pushColumnsField(this.serviceColumns);
      // } else {
      //   this.getServiceColumns();
      // }
      this.prepareColumns();
    } else {
      this.mob_columns();
      this.prepareColumnsArray_mobile();
    }
  }

  restoreData() {
    this.invoiceDisplayData = this.ds.invoiceLoadedData;
    this.serviceinvoiceDispalyData = this.ds.serviceinvoiceLoadedData;
    this.filterDataService = this.serviceinvoiceDispalyData;
    this.filterData = this.invoiceDisplayData;
    this.allInvoiceLength = this.ds.invoiceLoadedData.length;
    this.statusChartData = this.ds.statusChartData;
    if (this.allInvoiceLength == 0) this.allInvoiceLength = undefined;
    if (this.allInvoiceLength > 10 && this.isDesktop) {
      this.showPaginatorAllInvoice = true;
    }
    this.serviceInvoiceLength = this.serviceinvoiceDispalyData.length;
    if (this.serviceInvoiceLength == 0) this.serviceInvoiceLength = undefined;
    if (this.serviceInvoiceLength > 10 && this.isDesktop) {
      this.showPaginatorServiceInvoice = true;
    }
    // this.filterForArchived();
    this.poDispalyData = this.ds.poLoadedData;
    this.poArrayLength = this.ds.POtableLength;
    if (this.poDispalyData.length > 10 && this.isDesktop) {
      this.showPaginatorPOTable = true;
    }
    // this.soDisplayData = this.ds.SODisplayData;
    // this.soArrayLength = this.ds.soArrayLength;
    // if (this.soDisplayData.length > 10 && this.isDesktop) {
    //   this.showPaginatorSOTable = true;
    // }
    this.GRNDispalyData = this.ds.GRNLoadedData;
    this.GRNArrayLength = this.ds.GRNTableLength;
    if (this.GRNDispalyData.length > 10 && this.isDesktop) {
      this.showPaginatorGRNTable = true;
    }
    this.archivedDisplayData = this.ds.archivedDisplayData;
    this.archivedLength = this.ds.ARCTableLength;
    if (this.archivedDisplayData.length > 10 && this.isDesktop) {
      this.showPaginatorArchived = true;
    }
    this.rejectedDisplayData = this.ds.rejectedDisplayData;
    this.rejectedLength = this.ds.rejectTableLength;
    if (this.rejectedDisplayData.length > 10 && this.isDesktop) {
      this.showPaginatorRejected = true;
    }
    this.receiptDispalyData = this.ds.receiptLoadedData;
    this.receiptArrayLength = this.ds.receiptLoadedData.length;
    this.visibleSidebar2 = this.sharedService.sidebarBoolean;

    if (this.ds.receiptLoadedData.length == 0) {
      // this.getDisplayReceiptdata();
    }
  }

  routeForTabs() {
    this.invoiceTab = `/${this.portal_name}/invoice/allInvoices`;
    this.POTab = `/${this.portal_name}/invoice/PO`;
    // this.SOTab = `/${this.portal_name}/invoice/SO`;
    this.GRNTab = `/${this.portal_name}/invoice/GRN`;
    this.archivedTab = `/${this.portal_name}/invoice/archived`;
    this.rejectedTab = `/${this.portal_name}/invoice/rejected`;
    this.serviceInvoiceTab = `/${this.portal_name}/invoice/ServiceInvoices`;
  }

  prepareColumns() {
    this.rejectedColumns = [
      // { dbColumnname: 'VendorName', columnName: 'Vendor Name' },
      { dbColumnname: 'docheaderID', columnName: 'Invoice Number' },
      { dbColumnname: 'PODocumentID', columnName: 'PO Number' },
      { dbColumnname: 'EntityName', columnName: 'Entity' },
      { dbColumnname: 'documentDescription', columnName: 'Description' },
      { dbColumnname: 'CreatedOn', columnName: 'Uploaded Date' },
      { dbColumnname: 'documentDate', columnName: 'Invoice Date' },
      { dbColumnname: 'InvoiceType', columnName: 'Invoice Type' },
      { dbColumnname: 'totalAmount', columnName: 'Amount' },
      // { dbColumnname: 'documentPaymentStatus', columnName: 'Status' },
    ];

    this.GRNColumns = [
      { dbColumnname: 'EntityName', columnName: 'Entity Name' },
      { dbColumnname: 'VendorName', columnName: 'Vendor Name' },
      { dbColumnname: 'PODocumentID', columnName: 'PO Number' },
      { dbColumnname: 'docheaderID', columnName: 'GRN Number' },
      { dbColumnname: 'InvoiceNumber', columnName: 'Invoice Number' },
      { dbColumnname: 'JournalNumber', columnName: 'Invoice reference' },
      { dbColumnname: 'documentDescription', columnName: 'Description' },
      { dbColumnname: 'grn_status', columnName: 'GRN Status' },
      { dbColumnname: 'CreatedOn', columnName: 'Received Date' },
      { dbColumnname: 'UpdatedOn', columnName: 'Updated Date' },
      { dbColumnname: 'firstName', columnName: 'Created By' },
      { dbColumnname: 'sourcetype', columnName: 'Source' }
    ];

    if (this.portal_name == 'customer') {
      if (!this.vendorInvoiceAccess) {
        this.partyType = 'Service'
      } else {
        this.partyType = 'Vendor'
      }
      this.rejectedColumns.unshift({
        dbColumnname: !this.vendorInvoiceAccess ? 'ServiceProviderName' : 'VendorName',
        columnName: `${this.partyType} Name`,
      });
      if (!this.vendorInvoiceAccess) {
        this.rejectedColumns = this.rejectedColumns.filter(col => col.dbColumnname !== 'PODocumentID')
      }
    }

    // this.rejectedColumns.forEach((e) => {
    //   if (!this.ds.ap_boolean && e.columnName == 'Invoice Number') {
    //     e.columnName = 'Document Number'
    //   }
    //   this.columnstodisplayrejected.push(e.dbColumnname);
    // });

    if(this.ds.configData.client_name == 'Cenomi'){
       this.GRNColumns.push({ dbColumnname: 'erpgrnnumber', columnName: 'ERP GRN Number' });
    }

    this.GRNColumns.forEach((e) => {
      this.columnstodisplayGRN.push(e.dbColumnname);
    });
    this.rejectedColumnLength = this.rejectedColumns.length + 1;
    this.GRNColumnLength = this.GRNColumns.length + 1;

  }
  dateRange() {
    this.dateFilterService.dateRange();
    this.minDate = this.dateFilterService.minDate;
    this.maxDate = this.dateFilterService.maxDate;

    let today = new Date();
    let day = today.getDate()
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevYear = year - 1;


    this.GRNMinDate = new Date();
    this.GRNMinDate.setDate(day)
    this.GRNMinDate.setMonth(month);
    this.GRNMinDate.setFullYear(prevYear);
  }

  findActiveRoute() {
    if (this.route.url == this.invoiceTab) {
      this.pageNumber = this.ds.invTabPageNumber;
      this.searchText = this.ds.invoiceGlobe;
      this.routeName = 'allInvoices';
      if (!this.invoiceColumns) {
        this.getInvoiceColumns();
      }
      if (this.ds.invoiceLoadedData.length == 0) {
        this.getInvoiceData();
      }

    } else if (this.route.url == this.POTab) {
      this.pageNumber = this.ds.poTabPageNumber;
      if (!this.poColumns) {
        this.getPOColumns();
      }
      if (this.ds.poLoadedData.length == 0) {
        if (this.ds.searchPOStr != '') {
          this.getDisplayPOData(this.APIParams);
        } else {
          this.getDisplayPOData('?offset=1&limit=50');
        }
      }

      this.routeName = 'PO';
      this.searchStr = this.ds.searchPOStr;
    } else if (this.route.url == this.archivedTab) {
      this.pageNumber = this.ds.arcTabPageNumber;
      if (!this.archivedColumns) {
        this.getArchivedColumns();
      }
      if (this.ds.archivedDisplayData.length == 0) {
        if (this.ds.searchArcStr != '') {
          this.getDisplayARCData(this.APIParams);
        } else {
          this.getDisplayARCData('?offset=1&limit=50');
        }
      }
      this.routeName = 'archived';
      this.searchStr = this.ds.searchArcStr;
    } else if (this.route.url == this.rejectedTab) {
      this.pageNumber = this.ds.rejTabPageNumber;
      this.routeName = 'rejected';
      if (this.ds.rejectedDisplayData.length == 0) {
        if (this.ds.searchRejStr != '') {
          this.getDisplayRejectedData(this.APIParams);
        } else {
          this.getDisplayRejectedData(`?offset=1&limit=50`);
        }
      }
      this.searchStr = this.ds.searchRejStr;
    } else if (this.route.url == this.GRNTab) {
      this.pageNumber = this.ds.grnTabPageNumber;
      if (this.ds.GRNLoadedData.length == 0) {
        if (this.ds.searchGRNStr != '') {
          this.getDisplayGRNdata(this.APIParams);
        } else {
          this.getDisplayGRNdata(`?offset=1&limit=50`);
        }
      }
      this.routeName = 'GRN';
      this.searchStr = this.ds.searchGRNStr;
    } else if (this.route.url == this.serviceInvoiceTab) {
      this.routeName = 'services';
      this.pageNumber = this.ds.serviceTabPageNumber;
      this.searchText = this.ds.serviceGlobe;
      if (!this.serviceColumns) {
        this.getServiceColumns();
      }
      if (this.ds.serviceinvoiceLoadedData.length == 0) {
        this.getDisplayServiceInvoicedata();
      }
    }
    setTimeout(() => {
      this.universalSearch(this.searchText);
    }, 1000);
  }
  getInvoiceData() {
    this.SpinnerService.show();
    this.showFactsComponent = true;
    let statusArray = [];
    this.sharedService.getAllInvoice(true).subscribe(
      (data: any) => {
        const invoicePushedArray = [];
        if (data) {
          this.refreshBool = false;
          data.ok.Documentdata.forEach((element) => {
            let invoiceData = {
              ...element.DocumentINV,
              ...element.Entity,
              ...element.DocumentSubStatus,
              ...element.VendorAccount,
              ...element.Vendor
            };
            // invoiceData.append('docStatus',element.docStatus)

            invoiceData['docstatus'] = element.docstatus;
            invoiceData['ITProjId'] = element?.ITProjId;
            invoiceData['POTypeDescription'] = element?.POTypeDescription;
            invoiceData['User'] = element?.User;
            invoiceData['Department'] = element?.Department;
            invoiceData['InvoiceType'] = element?.InvoiceType;
            invoiceData['approverData'] = element?.DocumentINV?.approverData?.to_approve_by;
            invoiceData['RequesterEmail'] = element?.DocumentINV?.flippo_Approvers_Data?.RequesterEmail;
            invoiceData['DepartmentName'] = element?.DocumentINV?.flippo_Approvers_Data?.DepartmentName;
            invoiceData['aging_status'] = element?.aging_status;
            invoiceData['isSerina'] = element?.DocumentINV?.isSerina == 0 ? 'ERP': 'Serina';
            if (this.portal_name == 'vendorPortal') {
              if (invoiceData['docstatus'] == 'Need To Review') {
                invoiceData['docstatus'] = 'Under Review';
              } else if (invoiceData['docstatus'] == 'Set Approval') {
                invoiceData['docstatus'] = 'Approval Pending';
              }
            }

            let docStatus = invoiceData['docstatus']?.toLowerCase();
            docStatus = docStatus?.trim();
            let subStatus = element?.DocumentSubStatus?.status?.toLowerCase();
            subStatus = subStatus?.trim();
            if(docStatus == 'need to review') {
              statusArray.push(subStatus);
            } else {
              statusArray.push(docStatus);
            }
            const matchingStatus = this.ds.statusInfo.find(ele =>
              (ele.status.toLowerCase() == docStatus && docStatus !== 'need to review') ||
              (docStatus === 'need to review' && subStatus == ele?.status?.toLowerCase())
            );
            if (matchingStatus) {
              invoiceData['description'] = matchingStatus.description;
              invoiceData['actionToBeTaken'] = matchingStatus.action;
              invoiceData['owner'] = matchingStatus.owner;
            }
            
            invoicePushedArray.push(invoiceData);
          });
          this.getStatusChartData(statusArray);
          this.invoiceDisplayData = invoicePushedArray;
          this.filterData = this.invoiceDisplayData;

          // this.filterForArchived();
          setTimeout(() => {
            this.universalSearch(this.searchText);
          }, 1000)
          this.allInvoiceLength = this.invoiceDisplayData.length;
          if (this.allInvoiceLength > 10 && this.isDesktop) {
            this.showPaginatorAllInvoice = true;
          }
          this.ds.invoiceLoadedData = invoicePushedArray;
          this.showFactsComponent = false;
        }
        this.SpinnerService.hide();
      },
      (error) => {
        this.error("Server error");
        this.SpinnerService.hide();
      }
    ), err => {
      this.SpinnerService.hide();
      this.error("Server error");
    };
  }
  getStatusChartData(statuses: string[]): void {
    // Create a map to count occurrences
    const statusCount: Record<string, number> = {};

    statuses.forEach((status: string) => {
      statusCount[status] = (statusCount[status] || 0) + 1;
    });

    // Sort statuses by count in descending order
    const sortedStatusArray = Object.entries(statusCount)
      .sort((a, b) => b[1] - a[1]);

    // Extract sorted statuses and counts
    const sortedStatuses = sortedStatusArray.map(([status]) => status);
    const sortedCounts = sortedStatusArray.map(([, count]) => count);

    // Build the result array
    const headerRow = ['count', ...sortedStatuses];
    const countRow = ['count', ...sortedCounts];

    const result = [headerRow, countRow];

    this.statusChartData = result;
    this.ds.statusChartData = this.statusChartData;
  }
  displayStatusChart(chartsData: any) {
    google.charts.load('current', {packages: ['corechart', 'bar']});
    google.charts.setOnLoadCallback(drawStacked);

    function drawStacked() {
          let data = google.visualization.arrayToDataTable(chartsData);
           const pastelColors: string[] = [
              '#B3CDE3', '#FBB4AE', '#CCEBC5', '#DECBE4', '#FED9A6',
              '#FFFFCC', '#E5D8BD', '#D9D9D9', '#BC80BD', '#CCEBC5',
              '#FFED6F', '#F2B5D4', '#B0E0E6', '#FAFAD2', '#E6E6FA',
              '#FFFACD', '#E0FFFF', '#F5F5DC', '#D8BFD8', '#F4A460',
              '#FFDEAD', '#FFE4E1', '#D3FFCE', '#FFDAB9', '#C1FFC1',
              '#EAEAEA', '#FFF0F5', '#F5F5F5', '#F8E0E6', '#FFF5EE'
            ];

          let options1 = {
            titlePosition: 'All Invoice statuses',
            legend: { position: 'top', alignment: 'end', textStyle: { fontSize: 12 },maxLines:3 },
            chartArea: { width: '85%', padding: '0', margin:0},
            bar: { groupWidth: '60%' },
            colors: pastelColors,
            isStacked: true,
            annotations: {
              alwaysOutside: true,
            },
            animation: {
              duration: 500,
              startup: true,
            },
            hAxis: {
              gridlines: {
                color: 'transparent',
                count: 0,
              },
              baselineColor: '#d3d3d3',
              showTextEvery : 1,
              textStyle: {
                color: '#0D0B3C',
                fontSize: 11, // 12, 18 whatever you want (don't specify px)
                bold: false, // true or false
                italic: false, // true of false
                overflow : 'visible'
              },
            },
            vAxis: {
              title: '',
              gridlines: {
                color: '#f3f3f3',
              },
              baselineColor: '#d3d3d3',
              textStyle: {
                color: '#0D0B3C',
                fontSize: 11, // 12, 18 whatever you want (don't specify px)
                bold: false, // true or false
                italic: false, // true of false
              },
            },
          };
          // const lightColors = ['#B3CDE3', '#FBB4AE', '#CCEBC5', '#DECBE4', '#FED9A6'];
          // options1.colors = lightColors.slice(0, chartsData[0].length);

          let chart = new google.visualization.BarChart(document.getElementById('chart_div'));
          chart.draw(data, options1);
        }
  }
  openOverlay(event) {
    event.stopPropagation();
    this.op.toggle(event);
    setTimeout(() => {
      this.displayStatusChart(this.statusChartData);
    }, 100);
  }
  getDisplayPOData(data) {
    this.SpinnerService.show();
    this.sharedService.getPOData(data).subscribe(
      (data: any) => {
        const poPushedArray = [];
        if (data.ok) {
          data.ok.podata.forEach((element) => {
            let poData = {
              ...element.DocumentPO,
              ...element.Entity,
              ...element.EntityBody,
              ...element.VendorAccount,
              ...element.Vendor,
            };
            poData['DepartmentName'] = element?.DocumentPO?.flippo_Approvers_Data?.DepartmentName;
            poData.docstatus = element.docstatus;
            poPushedArray.push(poData);
          });
        }
        if(this.filtereddataboolean){
          this.poDispalyData = poPushedArray;
        }
        else{
          this.poDispalyData =
          this.ds.poLoadedData.concat(poPushedArray);
        }
        this.ds.poLoadedData = this.poDispalyData;
        this.poArrayLength = data.ok.total_po;
        this.ds.POtableLength = data.ok.total_po;
        if (this.poDispalyData.length > 10 && this.isDesktop) {
          this.showPaginatorPOTable = true;
        }
        this.SpinnerService.hide();
      },
      (error) => {
        this.error("Server error");
        this.SpinnerService.hide();
      }
    );
  }

  getDisplayGRNdata(data) {
    this.SpinnerService.show();
    this.sharedService.getGRNdata(data).subscribe((data: any) => {
      let grnD = []
      data.grndata?.forEach(ele => {
        let merge = { ...ele.DocumentGRN }
        merge.EntityName = ele?.EntityName;
        merge.VendorName = ele?.VendorName;
        merge.firstName = ele?.firstName;
        merge.InvoiceNumber = ele?.InvoiceNumber;
        merge.grn_status = ele?.status;
        merge.erpgrnnumber = ele?.erpgrnnumber;
        grnD.push(merge)
      })
      if(this.filtereddataboolean){
        this.GRNDispalyData = grnD;
        this.ds.GRNLoadedData = this.GRNDispalyData;
        this.ds.GRNTableLength = data.grn_total;
        this.GRNArrayLength = data.grn_total;
      }
      else{
        this.GRNDispalyData = this.ds.GRNLoadedData.concat(grnD);
        this.ds.GRNLoadedData = this.GRNDispalyData;
        this.ds.GRNTableLength = data.grn_total;
        this.GRNArrayLength = data.grn_total;
      }
      if (this.GRNDispalyData.length > 10 && this.isDesktop) {
        this.showPaginatorGRNTable = true;
      }
      this.SpinnerService.hide();
    }, err => {
      this.SpinnerService.hide();
      this.error("Server error");
    });
  }

  getDisplayARCData(data) {
    this.SpinnerService.show();
    this.sharedService.getARCdata(data).subscribe((data: any) => {
      const invoicePushedArray = [];
      data?.result?.ven?.ok?.Documentdata?.forEach((element) => {
        let invoiceData = {
          ...element.DocumentINV,
          ...element.Entity,
          ...element.EntityBody,
          ...element.VendorAccount,
          ...element.Vendor,
          ...element.PaymentsInfo
        };

        // invoiceData.append('docStatus',element.docStatus)

        invoiceData['docstatus'] = element.docstatus;
        invoiceData['InvoiceType'] = element?.DocumentINV?.UploadDocTypeCategory  == 'credit' ? 'Invoice' : element?.DocumentINV?.UploadDocTypeCategory;
        invoicePushedArray.push(invoiceData);
      });

      data?.result?.ser?.ok?.Documentdata?.forEach((element) => {
        let invoiceData = {
          ...element.DocumentINV,
          ...element.Entity,
          ...element.EntityBody,
          ...element.ServiceProvider,
          ...element.ServiceAccount,
          ...element.PaymentsInfo
        };
        invoiceData['docstatus'] = element.docstatus;
        invoicePushedArray.push(invoiceData);
      });

      if(this.filtereddataboolean){
        this.archivedDisplayData  = invoicePushedArray;
        this.ds.archivedDisplayData = this.archivedDisplayData;
      }
      else{
        this.archivedDisplayData =
        this.ds.archivedDisplayData.concat(invoicePushedArray);
        this.ds.archivedDisplayData = this.archivedDisplayData;
      }
      
      this.archivedDisplayData.forEach((ele1) => {
        for (let name in ele1) {
          if (name == 'ServiceProviderName') {
            ele1['VendorName'] = ele1['ServiceProviderName'];
          }
        }
      });
      if (this.ds.posted_inv_type != 'ser') {
        this.ds.ARCTableLength = data?.result?.ven?.ok?.total_arc;
        this.archivedLength = data?.result?.ven?.ok?.total_arc;
      } else {
        this.ds.ARCTableLength = data?.result?.ser?.ok?.total_arc;
        this.archivedLength = data?.result?.ser?.ok?.total_arc;
      }
      if (this.archivedLength > 10 && this.isDesktop) {
        this.showPaginatorArchived = true;
      }
      this.SpinnerService.hide();
    }, err => {
      this.SpinnerService.hide();
      this.error("Server error");
    });
  }

  getDisplayRejectedData(data) {
    this.SpinnerService.show();
    this.sharedService.getRejecteddata(data).subscribe((data: any) => {
      const invoicePushedArray = [];
      data?.result?.ven?.ok?.Documentdata?.forEach((element) => {
        let invoiceData = {
          ...element.DocumentINV,
          ...element.Entity,
          ...element.EntityBody,
          ...element.DocumentHistoryLogINV,
          ...element.VendorAccount,
          ...element.Vendor,
        };
        invoiceData['docstatus'] = element.docstatus;
        invoiceData['InvoiceType'] = element?.DocumentINV?.UploadDocTypeCategory  == 'credit' ? 'Invoice' : element?.DocumentINV?.UploadDocTypeCategory;
        invoicePushedArray.push(invoiceData);
      });

      data?.result?.ser?.ok?.Documentdata?.forEach((element) => {
        let invoiceData = {
          ...element.DocumentINV,
          ...element.Entity,
          ...element.EntityBody,
          ...element.ServiceProvider,
          ...element.ServiceAccount
        };

        // invoiceData.append('docStatus',element.docStatus)

        invoiceData['docstatus'] = element.docstatus;
        invoicePushedArray.push(invoiceData);
      });
      this.rejectedDisplayData.forEach((ele1) => {
        for (let name in ele1) {
          if (name == 'ServiceProviderName') {
            ele1['VendorName'] = ele1['ServiceProviderName'];
          }
        }
      });
      if(this.filtereddataboolean){
        this.rejectedDisplayData = invoicePushedArray;
        this.ds.rejectedDisplayData = this.rejectedDisplayData;
      }
      else{
      this.rejectedDisplayData =
      this.ds.rejectedDisplayData.concat(invoicePushedArray);
      this.ds.rejectedDisplayData = this.rejectedDisplayData;
      }
      this.ds.rejectTableLength = data?.result?.ven?.ok?.total_rejected;
      this.rejectedLength = data?.result?.ven?.ok?.total_rejected;
      if (this.rejectedDisplayData.length > 10 && this.isDesktop) {
        this.showPaginatorRejected = true;
      }
      this.SpinnerService.hide();
    }, err => {
      this.SpinnerService.hide();
      this.error("Server error");
    });
  }

  getDisplayServiceInvoicedata() {
    this.SpinnerService.show();
    this.sharedService.getAllInvoice(false).subscribe(
      (data: any) => {
        const invoicePushedArray = [];
        if (data) {
          this.refreshBool = false;
          data.ok.Documentdata.forEach((element) => {
            let invoiceData = {
              ...element.DocumentINV,
              ...element.Entity,
              ...element.EntityBody,
              ...element.ServiceProvider,
              ...element.ServiceAccount,
              ...element.DocumentSubStatus
            };
            invoiceData['docstatus'] = element.docstatus;
            invoiceData['aging_status'] = element?.aging_status;
            invoicePushedArray.push(invoiceData);
          });
          const allInvoicesService = [];
          invoicePushedArray.forEach((ele) => {
            if (ele.documentStatusID == 14) {
              this.archivedDisplayData.push(ele);
            } else {
              allInvoicesService.push(ele);
            }
          });
          setTimeout(() => {
            this.serviceinvoiceDispalyData = allInvoicesService;
            this.filterDataService = this.serviceinvoiceDispalyData;
            this.filterds = this.serviceinvoiceDispalyData;
            this.ds.serviceinvoiceLoadedData = allInvoicesService;
            this.universalSearch(this.searchText);
            this.serviceInvoiceLength = this.serviceinvoiceDispalyData.length;
            if (this.serviceinvoiceDispalyData.length > 10 && this.isDesktop) {
              this.showPaginatorServiceInvoice = true;
            }
             this.SpinnerService.hide();
          }, 50);
        }
      },
      (error) => {
        this.error("Server error");
        this.SpinnerService.hide();
      }
    );
  }

  getInvoiceColumns() {
    this.columnsFunc('INV', 'invTabColumns');
  }

  getPOColumns() {
    this.columnsFunc('PO', 'poTabColumns');
  }

  columnsFunc(tabType, serviceTab_name) {
    this.updateColumns = [];
    this.SpinnerService.show();
    let columnArray = [];
    let columns_to_display = [];
    let columnLength: number;
    this.sharedService.readColumnInvoice(tabType).subscribe(
      (data: any) => {
        const pushedColumnsArray = [];
        data.col_data.forEach((element) => {
          let arrayColumn = {
            ...element.ColumnPosDef,
            ...element.DocumentColumnPos,
          };
          pushedColumnsArray.push(arrayColumn);
        });
        columnArray = pushedColumnsArray.filter((element) => {
          if (tabType == 'PO' && element.columnName == 'Vendor Name' && !this.ds.ap_boolean) {
            element.columnName = 'Customer Name';
          }
          if (tabType == 'ARC' && !this.ds.ap_boolean && element.columnName == 'Invoice Number') {
            element.columnName = 'Document Number';
          }
          return element.isActive == 1;
        });
        columns_to_display = this.pushColumnsField(columnArray);
        columnArray = columnArray.sort(
          (a, b) => a.documentColumnPos - b.documentColumnPos
        );

        columnLength = columnArray.length + 1;
        this.allColumns = pushedColumnsArray.sort(
          (a, b) => a.documentColumnPos - b.documentColumnPos
        );
        this.allColumns.forEach((val) => {
          let activeBoolean;
          if (val.isActive == 1) {
            activeBoolean = true;
          } else {
            activeBoolean = false;
          }
          this.updateColumns.push({
            idtabColumn: val.idDocumentColumn,
            ColumnPos: val.documentColumnPos,
            isActive: activeBoolean,
          });
        });
        // this.ds[serviceTab_name] = this.allColumns;
        // console.log(this.ds.invTabColumns)
        if (tabType == 'INV') {
          this.invoiceColumns = columnArray;
          this.columnstodisplayInvoice = columns_to_display;
          this.allInColumnLength = columnLength;
          this.invTabAllColumns = this.allColumns;
          this.ds.invTabColumns = this.allColumns;
        } else if (tabType == 'PO') {
          this.poColumns = columnArray;
          this.columnstodisplayPO = columns_to_display;
          this.allPOColumnLength = columnLength;
          this.poTabAllColumns = this.allColumns;
          this.ds.poTabColumns = this.allColumns;
        } else if (tabType == 'ARC') {
          this.archivedColumns = columnArray;
          this.columnstodisplayArchived = columns_to_display;
          this.allARCColumnLength = columnLength;
          this.arcTabAllColumns = this.allColumns;
          this.ds.arcTabColumns = this.allColumns;
        } else if (tabType == 'INVS') {
          this.serviceColumns = columnArray;
          this.columnstodisplayService = columns_to_display;
          this.allSRVColumnLength = columnLength;
          this.invsTabAllColumns = this.allColumns;
          this.ds.serTabColumns = this.allColumns;
        }
        if(this.invoiceDisplayData.length > 0 || this.serviceinvoiceDispalyData.length > 0) {
          this.SpinnerService.hide();
        }
      },
      (error) => {
        this.SpinnerService.hide();
        this.error("Server error");
      }
    );
  }

  getArchivedColumns() {
    this.columnsFunc('ARC', 'arcTabColumns');
  }

  getServiceColumns() {
    this.columnsFunc('INVS', 'serTabColumns');
  }

  getPOfilters() {
    this.sharedService.getPoFilterOption().subscribe((data: any) => {
    // const data = this.sharedService.getPoFilterOption();
     if (data) {
        this.dropdownGroups = [];

        // Handle string arrays by converting to objects with a `value` property
        const convertStringsToObjects = (arr: string[], fieldName: string) =>
          arr.map(item => ({ [fieldName]: item }));

        // Add vendors
        this.dropdownGroups.push({
          label: 'Vendor',
          field: 'value',
          data: convertStringsToObjects(data.vendors, 'value'),
          selected: null,
          filtered: []
        });

        // Add entities
        this.dropdownGroups.push({
          label: 'Entity',
          field: 'value',
          data: convertStringsToObjects(data.entities, 'value'),
          selected: null,
          filtered: []
        });

        // Add statuses
        this.dropdownGroups.push({
          label: 'Status',
          field: 'value',
          data: convertStringsToObjects(data.statuses, 'value'),
          selected: null,
          filtered: []
        });

        // Add users (already in object format)
      }
    });
  }
  filterGroup(event: any, group: any) {
  const query = event.query.toLowerCase();
  group.filtered = group.data.filter((item: any) =>
    item[group.field]?.toLowerCase().includes(query)
  );
  }


  getGRNfilters() {
    this.sharedService.getGrnFilterOption().subscribe((data: any) => {
    // const data = this.sharedService.getGrnFilterOption();
      if (data) {
        this.dropdownGroups = [];

        // Handle string arrays by converting to objects with a `value` property
        const convertStringsToObjects = (arr: string[], fieldName: string) =>
          arr.map(item => ({ [fieldName]: item }));

        // Add vendors
        this.dropdownGroups.push({
          label: 'Vendor',
          field: 'value',
          data: convertStringsToObjects(data.vendors, 'value'),
          selected: null,
          filtered: []
        });

        // Add entities
        this.dropdownGroups.push({
          label: 'Entity',
          field: 'value',
          data: convertStringsToObjects(data.entities, 'value'),
          selected: null,
          filtered: []
        });

        // Add statuses
        this.dropdownGroups.push({
          label: 'Status',
          field: 'value',
          data: convertStringsToObjects(data.statuses, 'value'),
          selected: null,
          filtered: []
        });

        // Add users (already in object format)
        this.dropdownGroups.push({
          label: 'Created By',
          field: 'fullName',
          data: data.users,
          selected: null,
          filtered: []
        });
      }
    });
  }

  getPostedFilters() {
    this.sharedService.getPostedFilterOption().subscribe((data: any) => {
      if (data) {
        this.dropdownGroups = [];

         const convertStringsToObjects = (arr: string[], fieldName: string) =>
          arr.map(item => ({ [fieldName]: item }));

        // Add vendors
          this.dropdownGroups.push({
            label: 'Vendor',
            field: 'value',
            data: convertStringsToObjects(data.vendors, 'value'),
            selected: null,
            filtered: []
          });

          this.dropdownGroups.push({
            label: 'Entity',
            field: 'value',
            data: convertStringsToObjects(data.entities, 'value'),
            selected: null,
            filtered: []
          });
          this.dropdownGroups.push({
            label: 'Service provider',
            field: 'value',
            data: convertStringsToObjects(data.service_providers, 'value'),
            selected: null,
            filtered: []
          });
      }
    });
    
  }
  getRejectedFilters(){

    this.sharedService.getRejectedFilterOption().subscribe((data: any) => {
      if (data) {
        this.dropdownGroups = [];

        const convertStringsToObjects = (arr: string[], fieldName: string) =>
          arr.map(item => ({ [fieldName]: item }));

        // Add vendors
          this.dropdownGroups.push({
            label: 'Vendor',
            field: 'value',
            data: convertStringsToObjects(data.vendors, 'value'),
            selected: null,
            filtered: []
          });

          this.dropdownGroups.push({
            label: 'Entity',
            field: 'value',
            data: convertStringsToObjects(data.entities, 'value'),
            selected: null,
            filtered: []
          });
          this.dropdownGroups.push({
            label: 'Service provider',
            field: 'value',
            data: convertStringsToObjects(data.service_providers, 'value'),
            selected: null,
            filtered: []
          });
      }
    });
  }
  applyDropdownFilters() {
  let queryParams = '';
    queryParams += `?offset=1&limit=50`
    if(this.poNumber){
      queryParams += `&po_number=${encodeURIComponent(this.poNumber)}`
    }
  this.dropdownGroups.forEach(group => {

    switch (group.label.toLowerCase()) {
      case 'vendor':
        if (group.selected?.VendorName) {
          queryParams += `&vendor_name=${encodeURIComponent(group.selected.VendorName)}`;
        }
        if (group.selected?.value) {
          queryParams += `&vendor_name=${encodeURIComponent(group.selected.value)}`;
        }
        if (group.selected?.name) {
          queryParams += `&vendor_name=${encodeURIComponent(group.selected.name)}`;
        }
        break;

      case 'entity':
        if (group.selected?.EntityName) {
          queryParams += `&entity_name=${encodeURIComponent(group.selected.EntityName)}`;
        }
        if (group.selected?.value) {
          queryParams += `&entity_name=${encodeURIComponent(group.selected.value)}`;
        }
        if (group.selected?.name) {
          queryParams += `&entity_name=${encodeURIComponent(group.selected.name)}`;
        }
        break;

      case 'status':
        if (group.selected?.status) {
          queryParams += `&status=${encodeURIComponent(group.selected.status)}`;
        }
        if (group.selected?.value) {
          queryParams += `&status=${encodeURIComponent(group.selected.value)}`;
        }
        break;

      case 'created by':
        if (group.selected?.fullName) {
          queryParams += `&created_by=${encodeURIComponent(group.selected.fullName)}`;
        }
        break;
        case 'service provider':
          if (group.selected?.name){
            queryParams += `&entity_name=${encodeURIComponent(group.selected.name)}`;
          }

      // Add more cases if needed
    }
  });
      if (this.poRangeDates && this.poRangeDates.length === 2) {
        const startDate = this.formatDate(this.poRangeDates[0]);
        const endDate = this.formatDate(this.poRangeDates[1]);
        queryParams += `&start_date=${encodeURIComponent(startDate)}`;
        queryParams += `&end_date=${encodeURIComponent(endDate)}`;
        // Now you can use startDate and endDate as needed
      } else if (this.poRangeDates && this.poRangeDates.length === 1) {
        const startDate = this.formatDate(this.poRangeDates[0]);
      }
      if(this.selectedType && this.archFilterBool){
        queryParams += `&inv_type=${encodeURIComponent(this.selectedType)}`;
      }


  if(this.poFilterBool){
    this.filtereddataboolean = true;
    this.getDisplayPOData(queryParams);
    this.visibleSidebar2 = false;
  }
  if(this.GRNFilterBool){
    this.filtereddataboolean = true;
    this.getDisplayGRNdata(queryParams);
    this.visibleSidebar2 = false;
  }
  if(this.archFilterBool){
    this.filtereddataboolean = true;
    this.getDisplayARCData(queryParams);
    this.visibleSidebar2 = false;
  }
  if(this.rejectedFilterBool){
    this.filtereddataboolean = true;
    this.getDisplayRejectedData(queryParams);
    this.visibleSidebar2 = false;
  }

}
formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
  resetDropdownFilters(){
    this.dropdownGroups.forEach(group => {
      group.selected = null;
      group.filtered = [];
    });
    this.applyDropdownFilters();
  }
  menuChange(value) {
    this.updateColumns = [];

    this.activeMenuName = value;
    // this.getInvoiceData();
    this.ds.allPaginationFirst = 0;
    this.ds.allPaginationRowLength = 10;
    if (value == 'invoice') {
      this.search_placeholder = 'Ex : By Vendor. By PO, Select Date range from the Calendar icon';
      this.route.navigate([this.invoiceTab]);
      this.ds.doc_status_tab = this.invoiceTab;
      this.allSearchInvoiceString = [];
      if (!this.invoiceColumns) {
        this.getInvoiceColumns();
      }
    } else if (value == 'po') {
      this.archFilterBool = false;
      this.poFilterBool = true;
      this.rejectedFilterBool = false;
      this.GRNFilterBool = false;
      if (!this.poColumns) {
        this.getPOColumns();
      }
      this.getPOfilters();
      this.route.navigate([this.POTab]);
      this.ds.doc_status_tab = this.POTab;
      this.allSearchInvoiceString = [];
      this.searchStr = this.ds.searchPOStr;
    }
    // else if (value == 'so') {
    //   // this.getPOColums();
    //   this.route.navigate([this.SOTab]);
    //   this.ds.doc_status_tab = this.SOTab;
    //   this.allSearchInvoiceString = [];
    //   this.searchStr = this.ds.searchSOStr;
    // } 
    else if (value == 'grn') {
      this.archFilterBool = false;
      this.poFilterBool = false;
      this.rejectedFilterBool = false;
      this.GRNFilterBool = true;
      this.getGRNfilters();
      this.route.navigate([this.GRNTab]);
      this.ds.doc_status_tab = this.GRNTab;
      this.allSearchInvoiceString = [];
      this.searchStr = this.ds.searchGRNStr;
    } else if (value == 'ServiceInvoices') {
      this.search_placeholder = 'Ex : By Service provider. By Account, Select Date range from the Calendar icon';
      if (!this.serviceColumns) {
        this.getServiceColumns();
      }
      this.route.navigate([this.serviceInvoiceTab]);
      this.ds.doc_status_tab = this.serviceInvoiceTab;
      this.allSearchInvoiceString = [];
    } else if (value == 'archived') {
      this.poFilterBool = false;
      this.rejectedFilterBool = false;
      this.GRNFilterBool = false;
      this.archFilterBool = true;
      this.getPostedFilters();
      if (!this.archivedColumns) {
        this.getArchivedColumns();
      }
      this.route.navigate([this.archivedTab]);
      this.ds.doc_status_tab = this.archivedTab;
      this.allSearchInvoiceString = [];
      this.searchStr = this.ds.searchArcStr;
    } else if (value == 'rejected') {
      this.archFilterBool = false;
      this.poFilterBool = false;
      this.GRNFilterBool = false;
      this.rejectedFilterBool = true;
      this.getRejectedFilters();
      this.route.navigate([this.rejectedTab]);
      this.ds.doc_status_tab = this.rejectedTab;
      this.allSearchInvoiceString = [];
      this.searchStr = this.ds.searchRejStr;
    }
    setTimeout(() => {
      this.findActiveRoute();
    }, 500);
  }
  searchInvoiceDataV(value) {
    this.allSearchInvoiceString = [];
    this.allSearchInvoiceString = value.filteredValue;
  }
  showSidebar(obj) {
    this.resetBool();
    this.visibleSidebar2 = true;
    this.isColumnSelection = obj.isColumnSelection;
    this.isStatusSearch = !this.isColumnSelection;
    if (obj.value == 'column') {
      this.sidebarHeader = 'Select Columns';
    } else {
      if (this.portal_name == 'vendorPortal') {
        this.ds.statusInfo = this.ds.statusInfo.filter((ele) => {
          return ele.isCustomerStatus == 0;
        });
      }
      this.sidebarHeader = 'Search Status';
    }
    // this.sidenav.toggle();
    if (this.route.url == this.invoiceTab) {
      this.allColumns = this.invTabAllColumns;
    } else if (this.route.url == this.POTab) {
      this.allColumns = this.poTabAllColumns;
    } else if (this.route.url == this.archivedTab) {
      this.allColumns = this.arcTabAllColumns;
    } else if (this.route.url == this.rejectedTab) {
      this.allColumns = this.arcTabAllColumns;
    } else if (this.route.url == this.serviceInvoiceTab) {
      this.allColumns = this.invsTabAllColumns;
    }
  }

  openSidebar(value) {
    this.visibleSidebar2 = true;  
    this.readEntity();
    this.getCustomerVendors();
    this.resetBool();
    if (value == 'PO') {
      this.sidebarHeader = 'Search PO Data';
      this.poFilterBool = true;
    } else if (value == 'GRN') {
      this.sidebarHeader = 'Search GRN Data';
      this.GRNFilterBool = true;
    }
    else if (value == 'posted') {
      this.sidebarHeader = 'Search Posted Data';
      this.archFilterBool = true;
    }
    else if (value == 'rejected') {
      this.sidebarHeader = 'Search Rejected Data';
      this.rejectedFilterBool = true;
    }
  }

  resetBool(){
    this.isStatusSearch = false;
    this.isColumnSelection = false;
    this.poFilterBool = false;
    this.GRNFilterBool = false;
  }

  exportExcel() {
    if (!this.route.url.includes('GRN')) {
      let exportData = [];
      if (!this.tableImportData) {
        if (this.route.url == this.invoiceTab) {
          exportData = this.invoiceDisplayData;
        } else if (this.route.url == this.POTab) {
          exportData = this.poDispalyData;
        } else if (this.route.url == this.GRNTab) {
          exportData = this.GRNDispalyData;
        } else if (this.route.url == this.archivedTab) {
          exportData = this.archivedDisplayData;
        } else if (this.route.url == this.rejectedTab) {
          exportData = this.rejectedDisplayData;
        } else if (this.route.url == this.serviceInvoiceTab) {
          exportData = this.serviceinvoiceDispalyData;
        }
      } else {
        exportData = this.tableImportData;
      }
      if(this.route.url == this.invoiceTab) {
        const fieldsToRemove = ['flippo_Approvers_Data', 'documentDescription','UploadDocTypeCategory','Address','idDocumentSubstatus' ,'idVendor','ITProjId','POTypeDescription','Department','User','approverData'];
        const fieldsToRename = {
          status: 'Substatus',
          docstatus: 'MainStatus',
          grn_documentID: 'GRNNumber',
          docheaderID: 'InvoiceNumber',
        };

        const cleanedData = exportData.map(obj => {
          const newObj = {};

          for (let key in obj) {
            if (!fieldsToRemove.includes(key)) {
              const newKey = fieldsToRename[key] || key;
              if(newKey == 'GRNNumber') {
                newObj[newKey] = obj[key]?.toString();
              } else {
                newObj[newKey] = obj[key];
              }
            }
          }

          return newObj;
        });
        exportData = cleanedData;
        this.exportData(exportData);
      } else {
        this.exportData(exportData);
      }

    } else {
      this.dialogHeader = "GRN Reports";
      this.getCustomerVendors();
      const dialog = document.querySelector('dialog');
      if (dialog) {
        dialog.showModal();
      }
    }
  }

  exportData(exportData){
      if (this.allSearchInvoiceString && this.allSearchInvoiceString.length > 0) {
        this.ImportExcelService.exportExcel(this.allSearchInvoiceString);
      } else if (exportData && exportData.length > 0) {
        this.ImportExcelService.exportExcel(exportData);
      } else {
        alert('No Data to import');
      }
  }
  openSOADialog(txt) {
    if (txt == 'soa') {
      this.getCustomerVendors();
      this.dialogHeader = "SOA Reports";
    } else {
      this.getServiceProviders();
      this.dialogHeader = "ERP Reports";
    }
    this.readEntity();

    const dialog = document.querySelector('dialog');
    if (dialog) {
      dialog.showModal();
    }
  }
  onOptionDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.allColumns, event.previousIndex, event.currentIndex);
    // if (this.route.url == '/customer/invoice/allInvoices') {
    this.allColumns.forEach((e, index) => {
      this.updateColumns.forEach((val) => {
        if (val.idtabColumn === e.idDocumentColumn) {
          val.ColumnPos = index + 1;
        }
      });
    });
  }
  activeColumn(e, value) {
    // if (this.route.url == '/customer/invoice/allInvoices') {
    this.updateColumns.forEach((val) => {
      if (val.idtabColumn == value.idDocumentColumn) {
        val.isActive = e.target.checked;
      }
    });
  }

  updateColumnPosition() {
    let param = '';
    let funName: string;
    if (this.route.url == this.invoiceTab) {
      param = 'INV';
      funName = 'getInvoiceColumns';
    } else if (this.route.url == this.POTab) {
      param = 'PO';
      funName = 'getPOColumns';
    } else if (this.route.url == this.archivedTab || this.route.url == this.rejectedTab) {
      param = 'ARC';
      funName = 'getArchivedColumns';
    } else if (this.route.url == this.serviceInvoiceTab) {
      param = 'INVS';
      funName = 'getServiceColumns';
    }
    this.sharedService.updateColumnPOs(this.updateColumns, param).subscribe(
      (data: any) => {
        this[funName]();
        this.AlertService.success_alert('Columns updated successfully')
      },
      (error) => {
        this.error(error.statusText);
      }
    );
    // this.sidenav.close();
    this.visibleSidebar2 = false;
  }

  filterByDate(date) {
    if (date != '') {
      const frmDate = this.datePipe.transform(date[0], 'yyyy-MM-dd');
      const toDate = this.datePipe.transform(date[1], 'yyyy-MM-dd');
      // this.filterData = [];
      this.search_placeholder = `From "${frmDate}" to "${toDate}"`;
      if (frmDate && toDate) {
        if (this.datePicker.overlayVisible) {
          this.datePicker.hideOverlay();
        }
        if (this.route.url == this.invoiceTab) {
          this.invoiceDisplayData = this.filterData;
          this.invoiceDisplayData = this.invoiceDisplayData.filter((element) => {
            const dateF = this.datePipe.transform(element.CreatedOn, 'yyyy-MM-dd')
            return dateF >= frmDate && dateF <= toDate;
          });
          this.allInvoiceLength = this.invoiceDisplayData?.length;
        } else if (this.route.url == this.serviceInvoiceTab) {
          this.serviceinvoiceDispalyData = this.filterDataService;
          this.serviceinvoiceDispalyData = this.serviceinvoiceDispalyData.filter(
            (element) => {
              const dateF = this.datePipe.transform(element.CreatedOn, 'yyyy-MM-dd')
              return dateF >= frmDate && dateF <= toDate;
            }
          );
          this.serviceInvoiceLength = this.serviceinvoiceDispalyData.length;
        } else if (this.route.url == this.archivedTab) {
          this.archivedDisplayData = this.filterDataArchived;
          this.archivedDisplayData = this.archivedDisplayData.filter(
            (element) => {
              const dateF = this.datePipe.transform(element.CreatedOn, 'yyyy-MM-dd')
              return dateF >= frmDate && dateF <= toDate;
            }
          );
          this.archivedLength = this.archivedDisplayData.length;
        }
      }
    } else {
      this.invoiceDisplayData = this.filterData;
      this.allInvoiceLength = this.invoiceDisplayData.length;
      this.serviceinvoiceDispalyData = this.filterDataService;
      this.serviceInvoiceLength = this.serviceinvoiceDispalyData.length;
      this.search_placeholder = 'Ex : By Vendor. By PO, Select Date range from the Calendar icon';
    }
  }
  clearDates() {
    this.filterByDate('');
  }

  filterByDateGRN(date) {
    const date1 = this.datePipe.transform(date[0], 'yyyy-MM-dd');
    const date2 = this.datePipe.transform(date[1], 'yyyy-MM-dd');
    if (date1 && date2) {
      if (this.datePicker_grn.overlayVisible) {
        this.datePicker_grn.hideOverlay();
      }
    }
  }

  clearDatesGRN() {
    delete this.rangeDates;
  }

  paginate(event) {
    if (this.ds.isTableView) {
      this.first = event.first;
    } else {
      this.first = event.pageNumber;
    }
    if (this.route.url == this.invoiceTab) {
      this.changePageInsession('allInvoices', this.first);
      this.ds.allPaginationFirst = this.first;
      this.ds.allPaginationRowLength = event.rows;
    } else if (this.route.url == this.POTab) {
      this.changePageInsession('PO', this.first);
      this.ds.poPaginationFirst = this.first;
      this.ds.poPaginationRowLength = event.rows;
      if (this.first >= this.ds.pageCountVariablePO) {
        this.ds.pageCountVariablePO = this.first;
        if (this.ds.searchPOStr == '') {
          this.ds.offsetCountPO++;
          this.APIParams = `?offset=${this.ds.offsetCountPO}&limit=50`;
          this.getDisplayPOData(this.APIParams);
        } else {
          this.ds.offsetCountPO++;
          this.APIParams = `?offset=${this.ds.offsetCountPO}&limit=50&uni_search=${this.ds.searchPOStr}`;
          this.getDisplayPOData(this.APIParams);
        }
      }
    } else if (this.route.url == this.GRNTab) {
      this.changePageInsession('GRN', this.first);
      this.ds.GRNPaginationFirst = this.first;
      this.ds.GRNPaginationRowLength = event.rows;
      if (this.first >= this.ds.pageCountVariableGRN) {
        this.ds.pageCountVariableGRN = this.first;
        if (this.ds.searchGRNStr == '') {
          this.ds.offsetCountGRN++;
          this.APIParams = `?offset=${this.ds.offsetCountGRN}&limit=50`;
          this.getDisplayGRNdata(this.APIParams);
        } else {
          this.ds.offsetCountGRN++;
          this.APIParams = `?offset=${this.ds.offsetCountGRN}&limit=50&uni_search=${this.ds.searchGRNStr}`;
          this.getDisplayGRNdata(this.APIParams);
        }
      }
    } else if (this.route.url == this.archivedTab) {
      this.changePageInsession('Archived', this.first);
      this.ds.archivedPaginationFirst = this.first;
      this.ds.archivedPaginationRowLength = event.rows;
      if (this.first >= this.ds.pageCountVariableArc) {
        this.ds.pageCountVariableArc = this.first;
        if (this.ds.searchArcStr == '' && this.ds.posted_inv_type == '') {
          this.ds.offsetCountArc++;
          this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50`;
          this.getDisplayARCData(this.APIParams);
        } else if (this.ds.searchArcStr == '' && this.ds.posted_inv_type != '') {
          this.ds.offsetCountArc++;
          this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50&inv_type=${this.ds.posted_inv_type}`;
          this.getDisplayARCData(this.APIParams);
        } else if (this.ds.searchArcStr != '' && this.ds.posted_inv_type != '') {
          this.ds.offsetCountArc++;
          this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50&uni_search=${this.ds.searchArcStr}&inv_type=${this.ds.posted_inv_type}`;
          this.getDisplayARCData(this.APIParams);
        } else {
          this.ds.offsetCountArc++;
          this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50&uni_search=${this.ds.searchArcStr}`;
          this.getDisplayARCData(this.APIParams);
        }
      }
    } else if (this.route.url == this.rejectedTab) {
      this.changePageInsession('Archived', this.first);
      this.ds.rejectedPaginationFirst = this.first;
      this.ds.rejectedPaginationRowLength = event.rows;
      if (this.first >= this.ds.pageCountVariableRej) {
        this.ds.pageCountVariableRej = this.first;
        if (this.ds.searchRejStr == '') {
          this.ds.offsetCountRej++;
          this.APIParams = `?offset=${this.ds.offsetCountRej}&limit=50`;
          this.getDisplayRejectedData(this.APIParams);
        } else {
          this.ds.offsetCountRej++;
          this.APIParams = `?offset=${this.ds.offsetCountRej}&limit=50&uni_search=${this.ds.searchRejStr}`;
          this.getDisplayRejectedData(this.APIParams);
        }
      }
    }
    // else if (this.route.url == this.SOTab) {
    //   this.ds.SOPaginationFirst = this.first;
    //   this.ds.SOPaginationRowLength = event.rows;
    //   if (this.first >= this.ds.pageCountVariableSO) {
    //     this.ds.pageCountVariableSO = event.first;
    //     if (this.ds.searchSOStr == '') {
    //       this.ds.offsetCountSO++;
    //       this.APIParams = `?offset=${this.ds.offsetCountSO}&limit=50`;
    //       this.getDisplaySOData(this.APIParams);
    //     } else {
    //       this.ds.offsetCountSO++;
    //       this.APIParams = `?offset=${this.ds.offsetCountSO}&limit=50&uni_search=${this.ds.searchSOStr}`;
    //       this.getDisplaySOData(this.APIParams);
    //     }
    //   }
    // } 
    else if (this.route.url == this.serviceInvoiceTab) {
      this.changePageInsession('Service', this.first);
      this.ds.servicePaginationFirst = this.first;
      this.ds.servicePaginationRowLength = event.rows;
    }
  }

  changePageInsession(item, count) {
    let sessionData = sessionStorage.getItem(item);
    if (sessionData) {
      let session = JSON.parse(sessionData);
      session.first = count;
      sessionStorage.setItem(item, JSON.stringify(session));
    }
  }

  keySearch(str, event: KeyboardEvent) {
    str = str.trim();
    this.searchStr = str;
    if (str == '') {
      this.filterString(str);
      // this.APIParams = `?offset=1&limit=50`
      // if (this.route.url == this.invoiceTab) {
      // } else if (this.route.url == this.POTab) {
      //   this.ds.poLoadedData = [];
      //   this.ds.searchPOStr = str;
      //   this.getDisplayPOData(this.APIParams);
      // } else if (this.route.url == this.GRNTab) {
      //   this.ds.GRNLoadedData = [];
      //   this.ds.searchGRNStr = str;
      //   this.getDisplayGRNdata(this.APIParams);
      // } else if (this.route.url == this.archivedTab) {
      //   this.ds.searchArcStr = str;
      //   this.ds.archivedDisplayData = [];
      //   this.getDisplayARCData(this.APIParams);
      // } else if (this.route.url == this.rejectedTab) {
      //   this.ds.rejectedDisplayData = [];
      //   this.ds.searchRejStr = str;
      //   this.getDisplayRejectedData(this.APIParams);
      // } 
      // // else if (this.route.url == this.SOTab) {
      // //   this.ds.SODisplayData = [];
      // //   this.getDisplaySOData(this.APIParams);
      // // } 
      // else if (this.route.url == this.serviceInvoiceTab) {
      // }
    }
    if (event.key === 'Enter') {
      this.filterString(str);
    }
  }

  filterString(event) {
    if (this.route.url == this.invoiceTab) {
      // this.ds.allPaginationFirst = 0;
    } else if (this.route.url == this.POTab) {
      this.ds.poPaginationFirst = 0;
      this.ds.offsetCountPO = 1;
      this.ds.poLoadedData = [];
      this.ds.pageCountVariablePO = 0;
      this.ds.searchPOStr = event;
      if (this.ds.searchPOStr == '') {
        this.APIParams = `?offset=${this.ds.offsetCountPO}&limit=50`;
        this.getDisplayPOData(this.APIParams);
      } else {
        this.APIParams = `?offset=${this.ds.offsetCountPO}&limit=50&uni_search=${this.ds.searchPOStr}`;
        this.getDisplayPOData(this.APIParams);
      }
      // this.ds.poPaginationFisrt = 1;
    } else if (this.route.url == this.GRNTab) {
      this.ds.GRNPaginationFirst = 0;
      this.ds.offsetCountGRN = 1;
      this.ds.GRNLoadedData = [];
      this.ds.pageCountVariableGRN = 0;
      this.ds.searchGRNStr = event;
      if (this.ds.searchGRNStr == '') {
        this.APIParams = `?offset=${this.ds.offsetCountGRN}&limit=50`;
        this.getDisplayGRNdata(this.APIParams);
      } else {
        this.APIParams = `?offset=${this.ds.offsetCountGRN}&limit=50&uni_search=${this.ds.searchGRNStr}`;
        this.getDisplayGRNdata(this.APIParams);
      }
      // this.ds.GRNPaginationFisrt = 1;
    } else if (this.route.url == this.archivedTab) {
      this.ds.archivedPaginationFirst = 0;
      this.ds.offsetCountArc = 1;
      this.ds.archivedDisplayData = [];
      this.ds.pageCountVariableArc = 0;
      this.ds.searchArcStr = event;
      if (this.ds.searchArcStr == '' && this.ds.posted_inv_type == '') {
        this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50`;
        this.getDisplayARCData(this.APIParams);
      } else if (this.ds.searchArcStr == '' && this.ds.posted_inv_type != '') {
        this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50&inv_type=${this.ds.posted_inv_type}`;
        this.getDisplayARCData(this.APIParams);
      } else if (this.ds.searchArcStr != '' && this.ds.posted_inv_type != '') {
        this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50&uni_search=${this.ds.searchArcStr}&inv_type=${this.ds.posted_inv_type}`;
        this.getDisplayARCData(this.APIParams);
      } else {
        this.APIParams = `?offset=${this.ds.offsetCountArc}&limit=50&uni_search=${this.ds.searchArcStr}`;
        this.getDisplayARCData(this.APIParams);
      }
      // this.ds.archivedPaginationFisrt = 1;
    } else if (this.route.url == this.rejectedTab) {
      this.ds.rejectedPaginationFirst = 0;
      this.ds.offsetCountRej = 1;
      this.ds.rejectedDisplayData = [];
      this.ds.pageCountVariableRej = 0;
      this.ds.searchRejStr = event;
      if (this.ds.searchRejStr == '') {
        this.APIParams = `?offset=${this.ds.offsetCountRej}&limit=50`;
        this.getDisplayRejectedData(this.APIParams);
      } else {
        this.APIParams = `?offset=${this.ds.offsetCountRej}&limit=50&uni_search=${this.ds.searchRejStr}`;
        this.getDisplayRejectedData(this.APIParams);
      }
      // this.ds.rejectedPaginationFisrt = 1;
    }
    // else if (this.route.url == this.SOTab) {
    //   this.ds.SOPaginationFirst = 0;
    //   this.ds.offsetCountSO = 1;
    //   this.ds.SODisplayData = [];
    //   this.ds.searchSOStr = event;
    //   if (this.ds.searchSOStr == '') {
    //     this.APIParams = `?offset=${this.ds.offsetCountSO}&limit=50`;
    //     this.getDisplaySOData(this.APIParams);
    //   } else {
    //     this.APIParams = `?offset=${this.ds.offsetCountSO}&limit=50&uni_search=${this.ds.searchSOStr}`;
    //     this.getDisplaySOData(this.APIParams);
    //   }
    //   // this.ds.rejectedPaginationFisrt = 1;
    // } 
    else if (this.route.url == this.serviceInvoiceTab) {
    }
  }
  selectinvType(val) {
    this.ds.archivedDisplayData = [];
    this.ds.posted_inv_type = val;
    this.getDisplayARCData(`?offset=${this.ds.offsetCountArc}&limit=50&inv_type=${val}`);
  }

  filterEmit(event) {
    this.tableImportData = event;
  }

  mob_columns() {
    this.invoiceColumns = [
      { columnName: 'Invoice Number', dbColumnname: 'docheaderID' },
      { columnName: 'Vendor Name', dbColumnname: 'VendorName' },
      { columnName: 'Entity', dbColumnname: 'EntityName' },
      { columnName: 'PO Number', dbColumnname: 'PODocumentID' }
    ];
    this.poColumns = [
      { columnName: 'Vendor Name', dbColumnname: 'VendorName' },
      { columnName: 'Entity', dbColumnname: 'EntityName' },
      { columnName: 'PO Number', dbColumnname: 'docheaderID' },
      { columnName: 'Status', dbColumnname: 'docstatus' }
    ];
    this.GRNColumns = [
      { columnName: 'GRN Number', dbColumnname: 'docheaderID' },
      { columnName: 'Vendor Name', dbColumnname: 'VendorName' },
      // { columnName : 'Entity', dbColumnname:'EntityName'},
      { columnName: 'PO Number', dbColumnname: 'PODocumentID' },
    ];
    this.archivedColumns = [
      { columnName: 'Invoice Number', dbColumnname: 'docheaderID' },
      { columnName: 'Vendor Name', dbColumnname: 'VendorName' },
      { columnName: 'PO Number', dbColumnname: 'PODocumentID' },
      { columnName: 'Payment status', dbColumnname: 'PaymentStatus' },
    ];
    this.rejectedColumns = this.invoiceColumns;
    this.serviceColumns = [
      { columnName: 'Invoice Number', dbColumnname: 'docheaderID' },
      { columnName: 'Service Provider', dbColumnname: 'ServiceProviderName' },
      { columnName: 'Entity', dbColumnname: 'EntityName' },
      { columnName: 'Service Account', dbColumnname: 'Account' }
    ];
  }

  // to prepare display columns array
  prepareColumnsArray_mobile() {
    this.invoiceColumns.filter((element) => {
      this.columnstodisplayInvoice.push(element.dbColumnname);
    });
    this.poColumns.filter((element) => {
      this.columnstodisplayPO.push(element.dbColumnname);
    });
    this.GRNColumns.filter((element) => {
      this.columnstodisplayGRN.push(element.dbColumnname);
    });
    this.archivedColumns.filter((element) => {
      this.columnstodisplayArchived.push(element.dbColumnname);
    });
    this.rejectedColumns.filter((element) => {
      this.columnstodisplayrejected.push(element.dbColumnname);
    });
    this.serviceColumns.filter((element) => {
      this.columnstodisplayService.push(element.dbColumnname);
    });

    this.allInColumnLength = this.invoiceColumns.length + 1;
    this.allPOColumnLength = this.poColumns.length + 1;
    this.GRNColumnLength = this.GRNColumns.length + 1;
    this.allARCColumnLength = this.archivedColumns.length + 1;
    this.rejectedColumnLength = this.rejectedColumns.length + 1;
    this.allSRVColumnLength = this.serviceColumns.length + 1;
  }

  refreshInvoice(type) {
    this.refreshBool = true;
    if (type == 'inv') {
      this.getInvoiceData();
    } else if (type == 'ser') {
      this.getDisplayServiceInvoicedata();
    } else if (type == 'PO') {
      this.ds.poLoadedData = [];
      this.getDisplayPOData(this.APIParams);
      this.refreshBool = false;
    } else if (type?.includes('GRN')) {
      let idDocument = type?.split('-')[1];
      this.deleteGRN(idDocument);
    }
  }
  deleteGRN(idDocument) {
    this.GRNDispalyData = this.ds.GRNLoadedData.filter(val => val.idDocument != idDocument);
  }
  pushColumnsField(element) {
    const arrayOfColumnId = [];
    element.forEach((e) => {
      arrayOfColumnId.push(e.dbColumnname);
    });
    return arrayOfColumnId;
  }


  universalSearch(txt) {
    txt = txt?.trim();
    if (this.route.url == this.serviceInvoiceTab) {
      this.ds.serviceGlobe = txt;
      this.serviceinvoiceDispalyData = this.filterDataService;
      this.serviceinvoiceDispalyData = this.ds.searchFilter(txt, this.filterDataService);
    } else if (this.route.url == this.invoiceTab) {
      this.ds.invoiceGlobe = txt;
      this.invoiceDisplayData = this.filterData;
      this.invoiceDisplayData = this.ds.searchFilter(txt, this.filterData);
    }
  }
  closeDialog() {
    const dialog = document.querySelector('dialog');
    if (dialog) {
      dialog.close();
    }
  }

  grnDownloadSelection(str) {
    this.grnTabDownloadOpt = str;
  }

  email_download() {
    this.SpinnerService.show();
    let api_param = '';
    let api_body = {
      "email": this.userEmailID,
      "option": this.grnTabDownloadOpt
    }
    let frmDate, toDate;
    if (this.rangeDates) {
      frmDate = this.datePipe.transform(this.rangeDates[0], 'yyyy-MM-dd');
      toDate = this.datePipe.transform(this.rangeDates[1], 'yyyy-MM-dd');
    }
    const params: any = {};
    if (this.rangeDates) {
      params.start_date = frmDate;
      params.end_date = toDate;
    }
    if (this.createdById) {
      params.created_by = this.createdById;
    }
    if (this.selectedVendorId) {
      params.vendorId = this.selectedVendorId;
    }

    // Build query string from params
    const queryString = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');

    api_param = queryString ? `?${queryString}` : '';
    this.sharedService.downloadGRN(api_param, api_body).subscribe((data: any) => {
      this.success(data.result);
      this.SpinnerService.hide();
      this.closeDialog();
      delete this.rangeDates;
    })
  }
  success(msg) {
    this.AlertService.success_alert(msg);
  }
  error(msg) {
    this.AlertService.error_alert(msg);
  }
  onPageChange(number: number) {
    this.pageNumber = number;
  }
  readEntity() {
    this.ds.entityData.subscribe((data: []) => {
      this.entityList = data;
      this.filteredEnt = this.entityList;
      console.log(this.entityList);
    })
  }

  filterEntity(event) {
    let filtered: any[] = [];
    let query = event.query;

    if (this.entityList?.length > 0) {
      for (let i = 0; i < this.entityList?.length; i++) {
        let ent: any = this.entityList[i];
        if (ent.EntityName.toLowerCase().includes(query.toLowerCase())) {
          filtered.push(ent);
        }
      }
    }
    this.filteredEnt = filtered;
  }
  selectEntity(value) {
    // this.selectedEntityId = value.idEntity;
    this.sharedService.selectedEntityId = value.idEntity;
    this.entityName = value;
  }
  getCustomerVendors() {
    this.sharedService
      .getVendorsListToCreateNewlogin(`?offset=1&limit=100`)
      .subscribe((data: any) => {
        this.vendorsList = data.vendorlist;
        // this.filteredVendors = this.vendorsList
      });
  }
  filterVendor(event) {
    let query = event.query.toLowerCase();
    if (query != '') {
      this.sharedService.getVendorsListToCreateNewlogin(`?offset=1&limit=100&ven_name=${query}`).subscribe((data: any) => {
        this.filteredVendors = data.vendorlist;
      });
    } else {
      this.filteredVendors = this.vendorsList;
    }
  }
  getServiceProviders() {
    this.sharedService
      .readserviceprovider()
      .subscribe((data: any) => {
        let mergerdArray = [];
        data.forEach(element => {
          let spData = { ...element.Entity, ...element.ServiceProvider };
          mergerdArray.push(spData);
        });
        this.servicesList = mergerdArray;
        // this.filteredVendors = this.vendorsList
      });
  }
  filterService(event) {
    let filtered: any[] = [];
    let query = event.query;

    if (this.servicesList?.length > 0) {
      for (let i = 0; i < this.servicesList?.length; i++) {
        let ent: any = this.servicesList[i];
        if (ent.ServiceProviderName.toLowerCase().includes(query.toLowerCase())) {
          filtered.push(ent);
        }
      }
    }
    this.filteredService = filtered;
  }
  filterUser(event) {
    let filtered: any[] = [];
    let query = event.query;

    if (this.sharedService?.usersList?.length > 0) {
      for (let i = 0; i < this.sharedService?.usersList?.length; i++) {
        let ent: any = this.sharedService?.usersList[i];
        if (ent.firstName.toLowerCase().includes(query.toLowerCase())) {
          filtered.push(ent);
        }
      }
    }
    this.userList = filtered;
  }
  selectedUser(evnt) {
    this.createdById = evnt?.userID;
  }
  selectedVendor(val) {
    this.selectedVendorId = val.idVendor;
  }
  soaSearch(bool) {
    // Initialize API parameter with usertype and filter_type
    let apiParam = `?usertype=${this.userDetails.user_type}&filter_type=${bool}`;

    // Add entity ID if selected
    if (this.selectedEntityId) {
      let ent_id = this.selectedEntityId?.idEntity;
      apiParam += `&ent_id=${ent_id}`;
    }

    // Add vendor ID if selected
    if (this.selectedVendorId) {
      let ven_name = this.selectedVendorId?.VendorName;
      apiParam += `&ven_name=${ven_name}`;
    }

    // Transform dates if rangeDates_soa is available
    let frmDate, toDate;
    if (this.rangeDates_soa) {
      frmDate = this.datePipe.transform(this.rangeDates_soa[0], 'yyyy-MM-dd');
      toDate = this.datePipe.transform(this.rangeDates_soa[1], 'yyyy-MM-dd');
      apiParam += `&start_date=${frmDate}&end_date=${toDate}`;
    }

    // Add unique search key if present
    if (this.soa_uniSearch) {
      apiParam += `&unq_key=${this.soa_uniSearch}`;
    }
    this.SpinnerService.show();
    this.sharedService.SOASearch(apiParam).subscribe((data: any) => {
      this.SpinnerService.hide();
      if (bool) {
        this.AlertService.success_alert("Dear User, The Report will be sent to your email shortly.")
        this.closeDialog();
      } else {
        this.SOATableData = data;
      }
    }, err => {
      this.SpinnerService.hide();
      this.AlertService.error_alert("Server error.");
    })
  }

  ERPReports(bool) {
    // Initialize API parameter with usertype and filter_type
    let apiParam = `?ismail=${bool}`;

    // Add entity ID if selected
    if (this.selectedEntityId) {
      let ent_id = this.selectedEntityId?.idEntity;
      apiParam += `&ent_id=${ent_id}`;
    }

    // Add service ID if selected
    if (this.selectedServiceId) {
      let sp_name = this.selectedServiceId?.ServiceProviderName;
      apiParam += `&SP_name=${sp_name}`;
    }

    // Transform dates if rangeDates_soa is available
    let frmDate, toDate;
    if (this.rangeDates_soa) {
      frmDate = this.datePipe.transform(this.rangeDates_soa[0], 'yyyy-MM-dd');
      toDate = this.datePipe.transform(this.rangeDates_soa[1], 'yyyy-MM-dd');
      apiParam += `&start_date=${frmDate}&end_date=${toDate}`;
    }

    // Add unique search key if present
    //  if (this.soa_uniSearch) {
    //    apiParam += `&unq_key=${this.soa_uniSearch}`;
    //  }
    this.SpinnerService.show();
    this.sharedService.ERPReportDownload(apiParam).subscribe((data: any) => {
      this.SpinnerService.hide();
      if (bool) {
        this.success("Dear User, The Report will be sent to your email shortly.");
        this.closeDialog();
      } else {
        this.sharedService.csvDownload(data);
        this.success("Dear User, The Report downloaded successfully.");
        this.closeDialog();
        //  this.SOATableData = data;
      }
    }, err => {
      this.SpinnerService.hide();
      this.error("Server error");
    })
  }
  DisplayCustomerUserDetails() {
    this.sharedService.readcustomeruser().subscribe((data: any) => {
      let usersList = [];
      data.forEach((element) => {
        let mergedData = {
          ...element.AccessPermission,
          ...element.AccessPermissionDef,
          ...element.User
        };
        mergedData.LogName = element?.LogName;
        usersList.push(mergedData);
      });
      this.userList = usersList;
      this.sharedService.usersList = usersList;
    });
  }
  setOpened(itemIndex) {
    this.currentlyOpenedItemIndex = itemIndex;
  }

  setClosed(itemIndex) {
    if (this.currentlyOpenedItemIndex === itemIndex) {
      this.currentlyOpenedItemIndex = -1;
    }
  }

    getEntitySummary() {
      this.ds.getEntity().subscribe((data: any) => {
        this.entityList = data.result;
      });
    }
}
